import css from 'styled-jsx/css';

export default css.global`
#featured-videos-widget .content-post .course-title { line-height: 0.875em; font-weight: 700; color: #3B4B5A; }
#featured-videos-widget .content-post .course-title .badge { font-size: 0.75rem; background: #1CB995; vertical-align: middle; }
#featured-videos-widget .content-post .subline { color: #3B4B5A; display: block; font-size: 0.875rem; margin: 7px 0 5px 0; }
#featured-videos-widget .content-post .excerpt { color: #3B4B5A; font-size: 1.125rem; margin: 0; }
#featured-videos-widget .content-post .metas { margin-top: 20px; }
#featured-videos-widget .content-post .metas .meta { margin-bottom: 6px; display: block; }
#featured-videos-widget .content-post .metas .badge { margin: 0; padding: 3px 8px; }
#featured-videos-widget .content-post .metas .cyber { font-size: 0.75rem; margin-bottom: 8px; }
#featured-videos-widget .content-post .metas .red-color { color: #FD011D; }
#featured-videos-widget hr { margin: 0; }

#single #featured-videos-widget ul li a { border: none; }
#single #featured-videos-widget .content-post.videos .thumb .play { width: 100%;height: 100%;position: absolute;left: 0;top: 0;z-index: 10;display: flex;align-items: center;justify-content: center; }
#single #featured-videos-widget .content-post.videos .thumb .play i {padding-left: 5px;width: 50px;height: 50px;line-height: 49px;background: rgba(55,72,88,.6);color: #fff;font-size: 1.5rem;text-align: center;border-radius: 50%;-moz-border-radius: 50%;-webkit-border-radius: 50%;-o-border-radius: 50%;border: 2px solid #fff; }

#single #featured-videos-widget { display: inline-block; }
#single #featured-videos-widget ul.tabs { margin: 0; color: #13364D; border-color: #13364D; padding: 15px 0; font-size: 1.25rem; display: flex; align-items: center; justify-content: space-between; position: relative; border-top: 2px solid #314e79; list-style: none; }

@media only screen and (max-width: 768px) {
  #featured-videos-widget .content-post.videos { min-height: 260px; height: auto; vertical-align: top; }
  #single #featured-videos-widget .content-post.videos { width: 100%; max-width: 100%; }
  #single #featured-videos-widget .content-post.videos,
  #single #featured-videos-widget .content-post.videos:nth-child(2n),
  #single #featured-videos-widget .content-post.videos:nth-child(odd) { padding: 0;}
  #single #featured-videos-widget ul.tabs li { margin: 0; }
}
`;
